module.exports = __webpack_public_path__ + "media/fonts/PPNeueMontreal-Italic-51ba2b6f.otf";